/* script */
export * from "!!babel-loader?{\"presets\":[\"/data/landun/workspace/build/node_modules/@babel/preset-env/lib/index.js\"],\"plugins\":[\"/data/landun/workspace/build/node_modules/@babel/plugin-proposal-object-rest-spread/lib/index.js\",\"/data/landun/workspace/build/node_modules/@babel/plugin-proposal-optional-chaining/lib/index.js\",\"/data/landun/workspace/build/node_modules/@babel/plugin-transform-runtime/lib/index.js\",\"/data/landun/workspace/build/node_modules/@babel/plugin-syntax-dynamic-import/lib/index.js\",\"/data/landun/workspace/build/plugins/babel-plugin-source-map-names.js\"]}!../../../build/node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue"
import __vue_script__ from "!!babel-loader?{\"presets\":[\"/data/landun/workspace/build/node_modules/@babel/preset-env/lib/index.js\"],\"plugins\":[\"/data/landun/workspace/build/node_modules/@babel/plugin-proposal-object-rest-spread/lib/index.js\",\"/data/landun/workspace/build/node_modules/@babel/plugin-proposal-optional-chaining/lib/index.js\",\"/data/landun/workspace/build/node_modules/@babel/plugin-transform-runtime/lib/index.js\",\"/data/landun/workspace/build/node_modules/@babel/plugin-syntax-dynamic-import/lib/index.js\",\"/data/landun/workspace/build/plugins/babel-plugin-source-map-names.js\"]}!../../../build/node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue"
/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../build/node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ../src/ui/photo-swipe/index.vue
// module id = 635
// module chunks = 0 1 2 3